import { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <>
      <Header />
      <main className="main-content">
        <div className="container-xl mb-5">
          {children}
        </div>
      </main>
      <Footer />
    </>
  );
}
